module.exports = __webpack_public_path__ + "img/fosunBg.b7101510.png";